import React from 'react';
import './svg.css';

const BlueTriangleRightArrow = () => {
  return (

    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.53628 5.44688C9.88171 5.73474 9.8817 6.26527 9.53628 6.55312L4.18096 11.0159C3.712 11.4067 3.00002 11.0732 3.00002 10.4628L3.00002 1.53723C3.00002 0.92679 3.712 0.593318 4.18096 0.984114L9.53628 5.44688Z" fill="#007C92"/>
    </svg>

  )
}

export default BlueTriangleRightArrow;